const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1']);

export function getApiBaseUrl() {
    const envBase = (process.env.REACT_APP_API_BASE_URL || '').trim();
    const host = window.location.hostname;
    const protocol = String(window.location.protocol || '').trim();
    const isLocalRuntime = LOCAL_HOSTS.has(host);

    if (isLocalRuntime) {
        if (envBase) {
            try {
                const parsed = new URL(envBase, window.location.origin);
                if (LOCAL_HOSTS.has(parsed.hostname)) {
                    return envBase.replace(/\/$/, '');
                }
            } catch (_err) {
                // Ignore malformed env values and fall back to local backend.
            }
        }

        return 'http://localhost:5001';
    }

    if (envBase) {
        let normalizedEnvBase = envBase;
        try {
            const parsed = new URL(envBase, window.location.origin);
            // Guard against malformed values like:
            // https://my-app.vercel.app/:5001
            if (/^\/:\d+(\/|$)/.test(parsed.pathname)) {
                parsed.pathname = parsed.pathname.replace(/^\/:\d+/, '');
                normalizedEnvBase = `${parsed.origin}${parsed.pathname}${parsed.search}${parsed.hash}`;
            }
            const envIsLocal = LOCAL_HOSTS.has(parsed.hostname);
            const isVercelWebRuntime = protocol === 'https:' && host.endsWith('.vercel.app');
            if (isVercelWebRuntime && !envIsLocal) {
                return '';
            }
        } catch (_err) {
            // Keep envBase when URL parsing fails.
        }
        return normalizedEnvBase.replace(/\/$/, '');
    }

    return isLocalRuntime ? 'http://localhost:5001' : '';
}
